import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { Floating, HideOnPrint } from 'components';
import Version from 'components/atoms/Version';

export const Panel = ({ children, screenId, screenName, spacing = 3, floatingDialogs, className }) => {
	useEffect(() => {
		window.screenId = screenId;
	}, [screenId]);

	return (
		<Box className={className} sx={{ mx: 2, mt: 4, pageBreakAfter: 'always', position: 'relative', zIndex: 1 }}>
			{floatingDialogs && <Floating>{floatingDialogs}</Floating>}
			<Stack spacing={spacing}>{children}</Stack>
			<HideOnPrint>
				<Version sx={{ mt: 3 }} screenId={screenId} screenName={screenName} />
			</HideOnPrint>
		</Box>
	);
};

Panel.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	floatingDialogs: PropTypes.any,
	screenId: PropTypes.string,
	screenName: PropTypes.string,
	spacing: PropTypes.number,
};

export default Panel;
